import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GcpSmAccesses } from "./accesses.ts";
import { GcpSmComponents } from "./components.ts";

const GcpSmFilters = {} as const satisfies AnyFilterSchema;
export type GcpSmFilters = typeof GcpSmFilters;

export const GcpSmRegistration = Registration({
  accesses: GcpSmAccesses,
  category: "resource",
  components: GcpSmComponents,
  docs: { install: "google-secret-manager" },
  filters: GcpSmFilters,
  itemKind: "Project",
  label: "Google Secret Manager",
  logoUrl:
    "https://www.gstatic.com/cloud/images/navigation/icons.svg#secretmanager",
  maturity: "preview",
  requestType: "bridge",
  useMapping: [
    { use: "iam_write", component: "iam-write" },
    { use: "identity", component: "iam-write" },
  ],
});

registerIntegration("gcp-sm", GcpSmRegistration);
